import React from "react";
import Cat from "../../assets/images/cat.png";
import BlackButton from "../../components/Button/BlackButton";
import "../Home/Home.module.css";
import styles from "../Home/Home.module.css";
import Star2 from "../../assets/images/star-svg.svg";
import Link from "react-scroll/modules/components/Link";
import Perfil from "../../assets/images/perfil.jpg";
import { useTranslation } from "react-i18next";
import { BsArrowUpCircleFill } from "react-icons/bs";
import WhiteButton from "../../components/Button/WhiteButton";

export default function Home()
{
  const { t, i18n } = useTranslation("global");

  return (
    <>
      <div className={styles.main} id="home">
        <div className={styles.info}>

          <div>
            <h2 className={styles.titles}>Barbara Bottazzi</h2>
            <h5 className={styles.subtitles}>{t("home.subtitle")}</h5>

            <Link
              to="about"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              activeClass="active"
            >
              <WhiteButton name={t("buttons.about")} />
            </Link>

          </div>
          <img
            src={Perfil}
            alt=""
            className={styles.imageHome}

          />
        </div>
        <div className={styles.starsBackground}>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
        </div>
        <div className={`${styles.star2} ${styles.starsBackground}`}>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2}></img>
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
          <div className="">
            <img src={Star2} alt="" />
          </div>
        </div>
      </div>
      <BsArrowUpCircleFill
        className={styles.arrowUp}
        onClick={() =>
        {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }}
      ></BsArrowUpCircleFill>
    </>
  );
}
